/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PersonSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M95.8877,48a32,32,0,1,1,32,32A32.03635,32.03635,0,0,1,95.8877,48Zm132.22851,73.13965C226.40527,120.11328,185.5542,96,128,96S29.59473,120.11328,27.88379,121.13965a8.00047,8.00047,0,0,0,8.23242,13.7207c.36133-.21686,34.9165-20.59765,83.88379-22.676v36.77447L58.02051,218.68555a7.99985,7.99985,0,1,0,11.959,10.6289L128,164.042l58.02051,65.27246a7.99985,7.99985,0,1,0,11.959-10.6289L136,148.95886V112.18567c48.769,2.08642,83.5293,22.46252,83.88379,22.67468a8.00047,8.00047,0,0,0,8.23242-13.7207Z" />
    </Svg>
  );
}

export default PersonSimple;
